<div class="footer__cfa-footer"
  [ngClass]="{'footer__cfa-footer-blue' : isBlueBackground}">
  @if (!(isMobile$ | async) || (isMobile$ | async) && showFooter) {
    <hr class="footer__dotted-line">
  }
  @if (!(isMobile$ | async)) {
    <div>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <p><a (click)="goToFeedback()" class="footer__feedback-text">We want your feedback!</a></p>
        </div>
        <div class="footer__version">
          v{{versionNumber}}
        </div>
        <div>
          <p>Copyright © {{currentYear}} Chick-fil-A, Inc. All rights reserved.</p>
        </div>
      </div>
    </div>
  }
  @if ((isMobile$ | async) && showFooter) {
    <div>
      <div fxLayout="column" fxLayoutAlign="space-around center">
        <div class="footer__mobile-version">
          v{{versionNumber}}
        </div>
        <div class="footer__mobile-copyright">
          <p>Copyright © {{currentYear}} Chick-fil-A, Inc.</p>
        </div>
        <div class="footer__mobile-copyright-text">
          <p>All rights reserved.</p>
        </div>
      </div>
    </div>
  }
  @if (isAdminUser$ | async) {
    <div class="footer__admin-debug">
      <spot-admin-debug-panel></spot-admin-debug-panel>
    </div>
  }
</div>
